import * as modals from './modal.slice';

export const openModal = modals.openModal;
export const closeModal = modals.closeModal;
export const resetModal = modals.resetModal;
